import {
  Component,
  OnInit,
  ViewEncapsulation,
  Input,
  Output,
  EventEmitter,
  OnChanges,
  SimpleChanges,
  OnDestroy,
  TemplateRef,
  ChangeDetectorRef
} from "@angular/core";

import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { DashboardService } from "src/app/core/services/dashboard.service";
import { DataIngestionService } from "src/app/core/services/dataIngestion.service";

@Component({
  selector: "app-ingestion-list-filter",
  templateUrl: "./ingestion-list-filter.component.html",
  styleUrls: ["./ingestion-list-filter.component.css"],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class IngestionListFilterComponent
  implements OnInit, OnChanges, OnDestroy
{
  modalRef: NgbModalRef | null = null;

  @Input() selectedIngestion: any = null;
  @Input() selectedIngestionIds: any = null;
  @Input() resetSelectionToken: number = 0;
  @Input() IngestionList: any[] = [];

  @Output() selectedIngestionChange = new EventEmitter<any>();

  completeTemplateList: any = [];
  reportPacks: any[] = [];
  selectedIngRows: any = null;
  loading = false;
  headerCols: any[] = [];
  ingForBannerDisplay: any = null;

  showEditPanel: boolean =false;

  constructor(
    private modalService: NgbModal,
    private dataIngestionService: DataIngestionService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.headerCols = [
      { field: "filename", header: "File Name" },
      { field: "reportPackId", header: "Report Pack ID" },
      { field: "reportPack", header: "Report Pack Title" },
      { field: "username", header: "Ingested By" },
      { field: "createddate", header: "Ingested Date" },
      { field: "rowslandedcount", header: "Rows Landed" },
      { header: "Status" },
    ];

    if (this.IngestionList && this.IngestionList.length > 0) {
      this.reportPacks = JSON.parse(JSON.stringify(this.IngestionList));
    } else {
      this.loading = true;

      this.dataIngestionService.getIngestions().then(
        (data: any) => {
          this.IngestionList = JSON.parse(JSON.stringify(data || []));
          this.loading = false;
          this.cdr.detectChanges();
        },
        () => {
          this.loading = false;
          this.cdr.detectChanges();
        },
      );
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.hasOwnProperty("IngestionList") &&
        this.IngestionList &&
        this.IngestionList.length > 0) ||
      (changes.hasOwnProperty("selectedIngestionIds") &&
        this.selectedIngestionIds) ||
      (changes.hasOwnProperty("selectedIngestion") && this.selectedIngestion)
    ) {
      this.prepareDisplayList();
    }
  }

  prepareDisplayList() {
    if (this.selectedIngestion) {
      this.selectedIngRows = this.selectedIngestion;
    } else if (
      this.selectedIngestionIds &&
      this.IngestionList.length > 0 &&
      !Array.isArray(this.selectedIngestionIds) &&
      this.IngestionList.filter(
        (x) => x.IngestionId == this.selectedIngestionIds,
      ).length > 0
    ) {
      this.selectedIngestion = this.IngestionList.filter(
        (x) => x.IngestionId == this.selectedIngestionIds,
      );
      this.selectedIngRows = this.selectedIngestion;
    } else if (
      this.selectedIngestionIds &&
      this.IngestionList.length > 0 &&
      Array.isArray(this.selectedIngestionIds) &&
      this.IngestionList.filter(
        (x) =>
          x.IngestionId == this.selectedIngestionIds.indexOf(x.IngestionId),
      ).length > 0
    ) {
      this.selectedIngestion = this.IngestionList.filter((x) =>
        this.selectedIngestionIds.indexOf(x.IngestionId),
      );
      this.selectedIngRows = this.selectedIngestion;
    }

    if (this.selectedIngestion)
      this.ingForBannerDisplay = Array.isArray(this.selectedIngestion)
        ? this.selectedIngestion[0]
        : this.selectedIngestion;
  }

  ngOnDestroy(): void {
    this.closeModal();
  }

  /**
   * Sets Ingestion list
   */
  async setSelectedIngestion() {
    this.closeModal();

    this.selectedIngestion = this.selectedIngRows;
    this.ingForBannerDisplay = this.selectedIngestion;
    this.cdr.detectChanges();
    var row = this.selectedIngestion;

    var model = {};

    model["reportpacktitle"] = row.reportPack;
    model["fileName"] = row.filename;
    model["reportpackid"] = row.reportPackId;
    model["loadId"] = row.loadid;
    model["currentStatus"] = row.loadstatus;
    model["reportingperiod"] = row.reportingperiod;
    model["tableId"] = row.tableId;
    model["priorReportPackId"] = row.priorReportPackId;

    this.dataIngestionService.ingestionLoadData = model;
this.showEditPanel=true;
    this.selectedIngestionChange.emit(this.selectedIngestion);
  }

  open(ingestionListFilter: TemplateRef<any>): void {
    this.modalRef = this.modalService.open(ingestionListFilter, {
      size: "xl",
      windowClass: "animated fadeInDown fast",
      scrollable: true,
      backdrop: false,
    });
  }

  closeModal(): void {
    if (this.modalRef) {
      this.modalRef.close();
      this.modalRef = null;
    }
  }
}
